"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.usePageVisible = function () {
    var _a = React.useState(false), isPageVisible = _a[0], setIsPageVisible = _a[1];
    function getBrowserVisibilityEvent() {
        if (typeof document.hidden !== "undefined") {
            return "visibilitychange";
        }
        else if (typeof document["webkitHidden"] !== "undefined") {
            return "webkitvisibilitychange";
        }
        return "visibilitychange";
    }
    function getBrowserDocumentHiddenProp() {
        if (typeof document.hidden !== "undefined") {
            return "hidden";
        }
        else if (typeof document["webkitHidden"] !== "undefined") {
            return "webkitHidden";
        }
        return "hidden";
    }
    var onFocus = function () { return setIsPageVisible(true); };
    var onBlur = function () { return setIsPageVisible(false); };
    var onVisibilityChange = function () {
        var isDocumentVisible = !document[getBrowserDocumentHiddenProp()];
        setIsPageVisible(isDocumentVisible);
    };
    var eventName = getBrowserVisibilityEvent();
    React.useEffect(function () {
        window.addEventListener(eventName, onVisibilityChange);
        window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onBlur);
        return function () {
            window.removeEventListener(eventName, onVisibilityChange);
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onBlur);
        };
    }, []);
    return isPageVisible;
};
//# sourceMappingURL=index.js.map